import SimpleModal from 'components/global/SimpleModal';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleSubmitDealDeleteSubmit } from 'components/views/FounderDeals/_helpers/founderDeals.events';
import { $form, $view } from 'signals/global.signals';

const FounderDealsDeleteModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-deal-delete'}
    title="Delete Deal"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={() => handleSubmitDealDeleteSubmit($form.value.id)}
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <div className="text-white">
      Are you sure you want to delete <b>{`${$form.value.name}`}</b>?
    </div>
  </SimpleModal>
);

export default FounderDealsDeleteModal;
